import { memo } from "react"

const IconInformativeBlue = () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Information">
        <g id="Information_2" clip-path="url(#clip0_12383_58746)">
          <path
            id="Information_3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 12.5C9.31368 12.5 12 9.81368 12 6.5C12 3.18629 9.31368 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81368 2.68629 12.5 6 12.5ZM6.6 4.1C6.6 4.43137 6.33138 4.7 6 4.7C5.66862 4.7 5.4 4.43137 5.4 4.1C5.4 3.76863 5.66862 3.5 6 3.5C6.33138 3.5 6.6 3.76863 6.6 4.1ZM5.4 5.9C5.4 5.56862 5.66862 5.3 6 5.3C6.33138 5.3 6.6 5.56862 6.6 5.9V8.9C6.6 9.23138 6.33138 9.5 6 9.5C5.66862 9.5 5.4 9.23138 5.4 8.9V5.9Z"
            fill="#002C98"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12383_58746">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(IconInformativeBlue)
